var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 535,
    height: 456,
    viewBox: "0 0 535 456",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1230_44605",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 70,
    width: 501,
    height: 366
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M534.004 70H34.8696V435.092H534.004V70Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1230_44605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.481 400.99C372.348 400.99 453.305 376.741 453.305 346.828C453.305 316.915 372.348 292.666 272.481 292.666C172.615 292.666 91.6572 316.915 91.6572 346.828C91.6572 376.741 172.615 400.99 272.481 400.99Z",
    fill: "url(#paint0_linear_1230_44605)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.325 285.841C159.325 285.841 159.245 285.626 159.137 285.855C158.165 287.918 149.365 310.263 148.667 327.509C148.667 327.509 147.198 337.417 159.504 337.286C169.778 337.177 169.504 328.043 169.468 324.965C169.327 312.484 159.325 285.841 159.325 285.841Z",
    fill: "url(#paint1_linear_1230_44605)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.044 348.257C158.846 348.257 158.684 348.088 158.684 347.882V291.849C158.684 291.642 158.846 291.473 159.044 291.473C159.242 291.473 159.404 291.642 159.404 291.849V347.882C159.404 348.092 159.242 348.257 159.044 348.257Z",
    fill: "url(#paint2_linear_1230_44605)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.585 357.986C388.132 357.15 390.602 356.058 392.854 353.001C393.315 352.375 393.75 351.572 393.496 350.823C393.306 350.259 392.754 349.897 392.195 349.805C391.986 349.772 391.775 349.767 391.565 349.786H391.562C391.239 349.821 390.92 349.888 390.609 349.984L390.52 350.012C389.035 350.459 387.619 351.136 386.32 352.021C386.202 352.1 386.063 352.135 385.924 352.12C385.785 352.104 385.655 352.04 385.555 351.937C385.456 351.833 385.392 351.697 385.374 351.551C385.356 351.404 385.387 351.255 385.459 351.129C385.591 350.9 385.746 350.685 385.919 350.489C386.175 350.205 386.455 349.948 386.756 349.72C387.157 349.41 387.584 349.134 388.002 348.852C389.556 347.804 391.028 346.625 392.404 345.328C393.386 344.401 394.347 343.373 394.814 342.07C395.028 341.471 395.126 340.78 394.87 340.2C394.448 339.246 393.252 338.979 392.274 339.177C390.56 339.525 389.191 340.855 387.977 342.182C386.97 343.284 385.842 344.503 384.395 344.571C384.149 344.596 383.901 344.543 383.682 344.42C383.27 344.155 383.164 343.542 383.311 343.055C383.458 342.568 383.798 342.179 384.126 341.805C386.036 339.636 387.915 337.379 389.155 334.72C390.394 332.062 390.944 328.923 390.082 326.101C389.83 325.276 389.45 324.473 388.858 323.873C388.266 323.274 387.436 322.898 386.623 323.013C385.515 323.167 384.681 324.157 384.12 325.179C382.192 328.686 382.31 332.983 381.766 337C381.615 338.124 381.394 339.278 380.761 340.203C380.703 340.292 380.627 340.367 380.539 340.423C380.019 340.742 379.552 340.098 379.356 339.552C378.585 337.391 378.392 334.92 377.011 333.131C376.484 332.451 375.738 331.882 374.907 331.887C373.892 331.895 373.023 332.792 372.726 333.821C372.43 334.849 372.608 335.967 372.925 336.988C373.514 338.881 374.57 340.582 375.814 342.078C376.469 342.867 377.211 343.665 377.408 344.695C377.469 345.045 377.443 345.405 377.335 345.742C377.227 346.079 377.039 346.381 376.789 346.619C376.673 346.726 376.537 346.808 376.39 346.859C376.243 346.91 376.088 346.929 375.934 346.915C375.601 346.883 375.299 346.703 375.008 346.528C374.886 346.455 374.764 346.38 374.641 346.307C374.156 346.014 373.671 345.721 373.185 345.428C371.951 344.683 370.462 343.921 369.177 344.563C368.521 344.891 368.092 345.536 367.89 346.277C367.709 346.949 367.709 347.661 367.89 348.333C368.272 349.73 370.685 353.619 371.68 354.622C372.842 355.793 376.873 360.846 385.585 357.986Z",
    fill: "url(#paint3_linear_1230_44605)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.775 332.117C308.038 331.359 308.215 330.501 308.265 329.492C308.292 328.958 308.239 328.338 307.823 328.021C307.51 327.783 307.071 327.801 306.726 327.973C306.598 328.038 306.478 328.119 306.369 328.214L306.368 328.216C306.201 328.363 306.048 328.528 305.911 328.706L305.871 328.756C305.21 329.598 304.672 330.54 304.275 331.551C304.239 331.642 304.174 331.717 304.091 331.764C304.008 331.811 303.912 331.827 303.819 331.81C303.726 331.791 303.64 331.741 303.577 331.666C303.513 331.592 303.475 331.497 303.469 331.398C303.458 331.217 303.465 331.036 303.49 330.858C303.528 330.598 303.589 330.342 303.673 330.095C303.761 329.827 303.866 329.564 303.972 329.302C303.997 329.239 304.021 329.177 304.046 329.115C304.525 327.911 304.91 326.667 305.199 325.396C305.405 324.488 305.561 323.531 305.342 322.619C305.242 322.2 305.042 321.776 304.687 321.554C304.103 321.192 303.34 321.52 302.869 322.02C302.044 322.898 301.772 324.185 301.584 325.408C301.429 326.424 301.25 327.554 300.471 328.168C300.343 328.28 300.186 328.35 300.019 328.369C299.693 328.386 299.409 328.086 299.312 327.756C299.215 327.426 299.261 327.074 299.306 326.734C299.571 324.764 299.787 322.757 299.5 320.781C299.213 318.806 298.366 316.838 296.851 315.609C296.408 315.25 295.903 314.954 295.354 314.856C294.804 314.759 294.205 314.88 293.796 315.268C293.237 315.796 293.137 316.68 293.2 317.473C293.363 319.53 294.34 321.372 295.313 323.208C295.629 323.803 295.944 324.398 296.231 324.998C296.56 325.685 296.86 326.416 296.848 327.185C296.849 327.257 296.834 327.329 296.805 327.395C296.634 327.78 296.138 327.608 295.829 327.382C295.431 327.09 295.055 326.755 294.68 326.421C293.903 325.73 293.129 325.04 292.169 324.74C291.626 324.571 291.003 324.551 290.543 324.886C289.982 325.295 289.828 326.142 290.041 326.833C290.254 327.524 290.763 328.076 291.314 328.518C292.336 329.338 293.547 329.865 294.787 330.202C294.851 330.219 294.915 330.236 294.98 330.253C295.577 330.413 296.194 330.577 296.634 331.024C296.796 331.195 296.914 331.406 296.978 331.637C297.041 331.868 297.048 332.111 296.996 332.343C296.971 332.449 296.925 332.549 296.863 332.636C296.8 332.723 296.72 332.795 296.63 332.849C296.433 332.964 296.199 332.984 295.973 333.003C295.943 333.005 295.912 333.008 295.881 333.01C295.817 333.015 295.753 333.02 295.688 333.026C295.311 333.056 294.934 333.087 294.557 333.117C293.597 333.194 292.49 333.364 292.012 334.234C291.768 334.678 291.766 335.209 291.926 335.702C292.072 336.149 292.333 336.545 292.68 336.848C293.138 337.242 294.291 337.869 295.311 338.32C296.75 339.62 300.889 339.608 305.957 339.593C306.515 339.591 307.084 339.589 307.662 339.589C308.24 339.589 308.809 339.591 309.367 339.593C315.683 339.612 320.558 339.626 320.558 337.098C320.558 334.362 314.846 332.141 307.775 332.117Z",
    fill: "url(#paint4_linear_1230_44605)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.998 139.057C225.526 139.057 225.614 139.02 225.922 138.837C225.614 133.685 230.877 134.642 233.315 137.741C234.65 135.878 238.757 135.768 239.681 135.659C240.092 138.837 237.217 139.714 237.32 139.824C237.402 139.911 239.1 140.909 239.681 141.201L241.324 140.324V143.065L239.476 142.188C239.168 142.48 238.314 143.38 237.32 143.884C229.311 146.734 228.592 141.139 228.284 140.481C228.037 139.955 227.428 139.824 227.154 139.824H223.971C224.006 139.605 224.417 139.057 224.998 139.057Z",
    fill: "#8FA8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.647 142.221C250.723 142.221 251.595 141.31 251.595 140.188C251.595 139.065 250.723 138.154 249.647 138.154C248.571 138.154 247.699 139.065 247.699 140.188C247.699 141.31 248.571 142.221 249.647 142.221Z",
    fill: "#8FA8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.271 142.221C261.347 142.221 262.219 141.31 262.219 140.188C262.219 139.065 261.347 138.154 260.271 138.154C259.195 138.154 258.323 139.065 258.323 140.188C258.323 141.31 259.195 142.221 260.271 142.221Z",
    fill: "#8FA8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.895 142.221C271.971 142.221 272.843 141.31 272.843 140.188C272.843 139.065 271.971 138.154 270.895 138.154C269.82 138.154 268.948 139.065 268.948 140.188C268.948 141.31 269.82 142.221 270.895 142.221Z",
    fill: "#8FA8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.52 142.221C282.596 142.221 283.468 141.31 283.468 140.188C283.468 139.065 282.596 138.154 281.52 138.154C280.444 138.154 279.572 139.065 279.572 140.188C279.572 141.31 280.444 142.221 281.52 142.221Z",
    fill: "#8FA8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.144 142.221C293.22 142.221 294.092 141.31 294.092 140.188C294.092 139.065 293.22 138.154 292.144 138.154C291.068 138.154 290.196 139.065 290.196 140.188C290.196 141.31 291.068 142.221 292.144 142.221Z",
    fill: "#8FA8FF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.645 216.892H182.082C179.828 216.892 178 218.72 178 220.974V300.663C178 302.918 179.828 304.745 182.082 304.745H375.57C377.825 304.745 379.652 302.918 379.652 300.663V220.974C379.652 218.72 377.825 216.892 375.57 216.892H309.552C309.552 228.205 295.694 237.376 278.598 237.376C261.504 237.376 247.645 228.205 247.645 216.892Z",
    fill: "url(#paint5_linear_1230_44605)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.953 165C216.698 165 214.871 166.828 214.871 169.082V218.258H247.645C247.645 229.571 261.504 238.742 278.599 238.742C295.694 238.742 309.552 229.571 309.552 218.258H342.781V169.082C342.781 166.828 340.954 165 338.699 165H218.953Z",
    fill: "url(#paint6_linear_1230_44605)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M215.782 165.455V218.258H179.366L215.782 165.455Z",
    fill: "#CBD1FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M341.871 165.455V218.258H378.287L341.871 165.455Z",
    fill: "#CBD1FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M379.738 140.066L363.899 157.686C363.699 157.906 363.437 158.01 363.123 157.999C362.963 157.988 362.805 157.939 362.662 157.846C362.569 157.785 362.481 157.696 362.398 157.583L358.511 151.975C358.298 151.668 357.911 151.537 357.558 151.651L352.654 153.249C352.374 153.347 352.103 153.308 351.842 153.139C351.733 153.068 351.651 152.989 351.593 152.903C351.471 152.738 351.403 152.557 351.397 152.35C351.389 152.144 351.437 151.955 351.548 151.782L354.077 147.814C354.289 147.481 354.607 147.235 354.979 147.111L374.075 140.837L353.153 143.846C352.995 143.867 352.836 143.799 352.747 143.668L349.195 138.537C348.957 138.213 348.935 137.868 349.139 137.498C349.339 137.144 349.637 136.978 350.031 137.002L379.069 138.431C379.248 138.436 379.405 138.487 379.55 138.581C379.721 138.693 379.843 138.842 379.919 139.025C380.073 139.412 380.005 139.759 379.738 140.066Z",
    fill: "url(#paint7_linear_1230_44605)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M345 148.631C340.985 146.462 314.523 148.631 305.58 175.553C300.49 190.876 293.17 203.199 272 200.669",
    stroke: "url(#paint8_linear_1230_44605)",
    strokeWidth: 3,
    strokeDasharray: "2 2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M218.269 323.439H206.221V335.598H218.269V323.439Z",
    fill: "url(#paint9_linear_1230_44605)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M225.077 320.225C226.104 320.644 227.5 319.579 228.193 317.847C228.887 316.114 228.616 314.37 227.588 313.951C226.56 313.532 225.165 314.596 224.471 316.329C223.778 318.061 224.049 319.806 225.077 320.225Z",
    fill: "#FEE0BC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M199.552 320.205C198.531 320.642 197.117 319.602 196.394 317.882C195.671 316.162 195.911 314.413 196.932 313.976C197.952 313.539 199.366 314.579 200.089 316.299C200.813 318.019 200.572 319.767 199.552 320.205Z",
    fill: "#FEE0BC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M212.769 328.373C220.146 328.373 226.126 322.377 226.126 314.98C226.126 307.583 220.146 301.587 212.769 301.587C205.391 301.587 199.411 307.583 199.411 314.98C199.411 322.377 205.391 328.373 212.769 328.373Z",
    fill: "url(#paint10_linear_1230_44605)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.512 293.602C217.089 292.937 217.423 292.15 217.423 291.307C217.423 288.913 214.73 286.972 211.408 286.972C208.087 286.972 205.394 288.913 205.394 291.307C205.394 292.287 205.846 293.192 206.607 293.918C195.296 297.306 193.543 311.013 199.193 316.002C201.619 308.658 223.449 308.658 225.875 316.002C230.248 310.116 228.708 296.271 216.512 293.602Z",
    fill: "url(#paint11_linear_1230_44605)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.483 331.177C217.75 330.924 218.016 330.644 218.281 330.336L218.286 330.338C218.386 330.338 218.508 330.359 218.74 330.526C219.916 331.051 221.003 331.832 221.997 332.78C233.188 337.968 246.868 353.189 247.606 357.051C248.465 361.544 246.725 363.945 244.963 364.806C244.08 365.238 237.898 367.397 231.17 369.229C231.946 378.553 232.846 387.567 233.746 389.859C234.346 391.388 229.728 391.971 223.238 392.046C210.139 393.334 187.872 393.044 189.122 389.861C190.019 387.576 190.916 378.61 191.691 369.315C185.812 367.934 180.564 366.299 179.733 365.88C178.015 365.013 174.578 361.544 175.437 356.341C176.1 352.328 192.706 335.447 203.885 330.64C204.116 330.529 204.349 330.428 204.587 330.338C204.59 330.341 204.593 330.345 204.596 330.348C204.613 330.342 204.631 330.335 204.649 330.328C204.65 330.335 204.651 330.342 204.652 330.349C205.532 329.704 206.113 329.46 206.253 329.46C207.637 331.274 210.552 333.673 213.808 333.137C215.287 332.709 216.578 331.971 217.483 331.177ZM192.774 355.562C192.878 354.219 192.977 352.96 193.07 351.816C191.952 352.735 190.668 353.671 189.184 354.607C190.311 354.77 191.519 355.105 192.774 355.562ZM230.14 356.167C230.049 354.991 229.962 353.874 229.879 352.835C230.94 353.657 232.141 354.493 233.507 355.328C232.446 355.476 231.314 355.769 230.14 356.167Z",
    fill: "url(#paint12_linear_1230_44605)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M219.84 331.066C219.84 331.066 218.986 330.174 218.133 330.174C213.535 334.979 208.326 331.64 206.182 329.282C206.102 329.19 205.328 329.282 204.475 330.174C211.987 337.31 217.848 333.742 219.84 331.066Z",
    fill: "#5B7EFB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M192.62 398.829L191.289 392.98L184.55 394.343L185.563 399.444L192.62 398.829Z",
    fill: "#FEE4C3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M186.631 393.7C185.295 395.806 186.15 398.624 186.744 399.769C185.058 401.535 178.015 403.254 178.015 398.832C178.015 394.494 182.32 392.914 186.631 393.7Z",
    fill: "#4F538F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M231.185 398.829L232.517 392.98L239.256 394.343L238.243 399.444L231.185 398.829Z",
    fill: "#FEE4C3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M237.175 393.7C238.51 395.806 237.656 398.624 237.061 399.769C238.747 401.535 245.79 403.254 245.79 398.832C245.791 394.494 241.486 392.914 237.175 393.7Z",
    fill: "#4F538F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M236.614 374.479C236.614 374.479 245.989 372.722 248.97 379.529C251.147 387.487 243.23 389.487 243.23 389.487L237.037 390.712L234.34 399.921L212.437 395.582L190.516 399.921L187.815 390.705L181.688 389.492C181.688 389.492 172.918 386.154 175.955 379.538C179.796 371.168 188.297 374.49 188.297 374.49L212.426 381.397L236.614 374.479Z",
    fill: "#D1E2FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M190.681 346.176C190.681 346.077 190.761 345.996 190.859 345.996H231.71C231.808 345.996 231.888 346.077 231.888 346.176V375.426H190.681V346.176Z",
    fill: "url(#paint13_linear_1230_44605)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M233.627 375.426H189.466C189.269 375.426 189.109 375.587 189.109 375.786V377.709C189.109 377.908 189.269 378.069 189.466 378.069H233.627C233.824 378.069 233.983 377.908 233.983 377.709V375.786C233.983 375.587 233.824 375.426 233.627 375.426Z",
    fill: "url(#paint14_linear_1230_44605)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M177.212 316.173C175.492 317.281 174.459 318.637 174.127 320.265C173.78 321.87 174.145 323.509 175.238 325.206L177.678 323.634C177.019 322.611 176.719 321.686 176.778 320.859C176.809 319.885 177.366 319.066 178.412 318.392C179.248 317.853 180.072 317.651 180.836 317.816C181.577 317.997 182.214 318.474 182.738 319.288C183.127 319.892 183.254 320.6 183.181 321.404L183.07 322.1C182.452 324.306 182.183 325.828 182.3 326.673C182.364 327.487 182.705 328.321 183.259 329.181L183.513 329.576L186 327.973L185.745 327.578C185.386 327.021 185.172 326.434 185.128 325.805C185.068 325.252 185.124 324.624 185.326 323.968C185.804 322.311 186.066 321.288 186.11 320.897C186.212 319.779 185.9 318.632 185.166 317.493C184.268 316.099 183.084 315.283 181.63 315.068C180.162 314.831 178.699 315.214 177.212 316.173ZM185.553 330.037C185.088 330.336 184.76 330.745 184.645 331.28C184.514 331.792 184.606 332.292 184.92 332.78C185.22 333.245 185.636 333.535 186.171 333.651C186.706 333.766 187.229 333.659 187.694 333.36C188.159 333.06 188.473 332.628 188.604 332.117C188.719 331.582 188.651 331.067 188.336 330.579C188.022 330.091 187.604 329.8 187.084 329.708C186.549 329.592 186.041 329.722 185.553 330.037Z",
    fill: "url(#paint15_linear_1230_44605)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M171.212 175.173C169.492 176.281 168.459 177.637 168.127 179.265C167.78 180.87 168.145 182.509 169.238 184.206L171.678 182.634C171.019 181.611 170.719 180.686 170.778 179.859C170.809 178.885 171.366 178.066 172.412 177.392C173.248 176.853 174.072 176.651 174.836 176.816C175.577 176.997 176.214 177.474 176.738 178.288C177.127 178.892 177.254 179.6 177.181 180.404L177.07 181.1C176.453 183.306 176.184 184.828 176.301 185.673C176.365 186.487 176.705 187.321 177.259 188.181L177.513 188.576L180 186.973L179.745 186.578C179.386 186.021 179.173 185.434 179.129 184.805C179.068 184.252 179.124 183.624 179.326 182.968C179.804 181.311 180.066 180.288 180.11 179.897C180.212 178.779 179.9 177.632 179.166 176.493C178.268 175.099 177.084 174.283 175.631 174.068C174.162 173.831 172.699 174.214 171.212 175.173ZM179.553 189.037C179.089 189.336 178.76 189.745 178.645 190.28C178.514 190.792 178.606 191.292 178.92 191.78C179.22 192.245 179.637 192.535 180.172 192.651C180.707 192.766 181.23 192.659 181.695 192.36C182.16 192.06 182.473 191.628 182.604 191.117C182.719 190.582 182.651 190.067 182.336 189.579C182.022 189.091 181.605 188.8 181.085 188.708C180.55 188.592 180.041 188.722 179.553 189.037Z",
    fill: "url(#paint16_linear_1230_44605)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M413.965 59.6949C411.057 55.235 406.136 52.4668 400.786 52.2807C397.683 47.5649 392.355 44.7642 386.681 44.8665C382.129 44.8181 377.749 46.5948 374.535 49.7942C373.062 49.3294 371.526 49.0905 369.98 49.086C362.828 49.086 356.907 53.9986 356.315 60.2073C350.863 61.4969 346.938 66.2234 346.704 71.7807C346.704 78.4716 352.883 83.9268 360.369 83.9268H412.842C420.433 83.9268 426.507 78.4716 426.507 71.7807C426.643 65.4214 421.026 60.1621 413.965 59.6949Z",
    fill: "url(#paint17_linear_1230_44605)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M511.949 42.0115C506.774 31.391 495.97 24.6326 484.109 24.596C477.503 24.6102 471.077 26.7417 465.783 30.6747C459.484 18.449 445.804 11.8593 432.261 14.5266C418.717 17.1938 408.59 28.4719 407.446 42.1635C392.876 46.7383 383.836 61.2019 386.153 76.2288C388.471 91.2557 401.453 102.356 416.731 102.373H502.985C518.351 102.402 531.412 91.2103 533.665 76.0847C535.917 60.9591 526.679 46.4789 511.965 42.0723L511.949 42.0115Z",
    fill: "url(#paint18_linear_1230_44605)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M109.912 155.422C107.878 144.855 98.4367 137.255 87.5242 137.399C81.6669 137.367 76.0126 139.512 71.6897 143.407C69.2339 142.359 66.5774 141.847 63.902 141.905C55.5132 141.762 48.1499 147.382 46.193 155.422C39.7181 156.833 35.049 162.407 34.8696 168.939C35.1186 176.889 41.828 183.152 49.8964 182.967H106.163C114.231 183.152 120.941 176.889 121.19 168.939C121.021 162.418 116.372 156.846 109.912 155.422Z",
    fill: "url(#paint19_linear_1230_44605)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M383.945 295.864L343.549 272.557C343.276 272.401 342.967 272.32 342.653 272.32C342.338 272.321 342.03 272.404 341.758 272.562C341.485 272.719 341.259 272.944 341.101 273.216C340.943 273.488 340.859 273.796 340.858 274.111L340.844 320.749C340.845 321.063 340.928 321.372 341.086 321.644C341.243 321.917 341.47 322.143 341.742 322.3C342.014 322.457 342.323 322.54 342.638 322.54C342.952 322.54 343.262 322.458 343.534 322.301L383.945 298.97C384.217 298.812 384.443 298.586 384.6 298.313C384.757 298.041 384.84 297.732 384.84 297.417C384.84 297.103 384.757 296.794 384.6 296.521C384.443 296.249 384.217 296.022 383.945 295.864ZM348.502 287.833C348.443 287.73 348.427 287.608 348.458 287.493C348.488 287.379 348.563 287.281 348.666 287.221L350.998 285.875C351.101 285.815 351.223 285.8 351.338 285.83C351.452 285.861 351.55 285.936 351.609 286.039L356.769 294.976C356.828 295.079 356.844 295.201 356.813 295.316C356.783 295.43 356.708 295.528 356.606 295.588L354.274 296.934C354.171 296.993 354.049 297.009 353.934 296.978C353.82 296.948 353.722 296.873 353.662 296.77L348.502 287.833ZM359.927 304.032C359.47 304.311 358.94 304.447 358.405 304.424C357.87 304.4 357.354 304.218 356.924 303.9C356.493 303.581 356.167 303.142 355.987 302.638C355.807 302.133 355.782 301.587 355.914 301.068C356.046 300.549 356.33 300.082 356.73 299.725C357.129 299.368 357.625 299.139 358.156 299.065C358.686 298.992 359.227 299.079 359.707 299.314C360.188 299.55 360.588 299.923 360.856 300.387C361.207 300.996 361.307 301.717 361.133 302.398C360.96 303.079 360.527 303.666 359.927 304.032Z",
    fill: "#92AAFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1230_44605",
    x1: 272.481,
    y1: 292.666,
    x2: 272.481,
    y2: 400.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95892,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1230_44605",
    x1: 159.042,
    y1: 337.291,
    x2: 159.042,
    y2: 285.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EB8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7893,
    stopColor: "#DFF0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1230_44605",
    x1: 159.043,
    y1: 291.473,
    x2: 159.043,
    y2: 348.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFF0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818,
    stopColor: "#A2BBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1230_44605",
    x1: 390.717,
    y1: 324.487,
    x2: 376.906,
    y2: 354.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.365159,
    stopColor: "#D5D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90A9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1230_44605",
    x1: 307.662,
    y1: 346.186,
    x2: 291.082,
    y2: 316.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.164037,
    stopColor: "#D5D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3B5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1230_44605",
    x1: 323.208,
    y1: 220.079,
    x2: 238.086,
    y2: 307.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADBDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2D7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1230_44605",
    x1: 307.039,
    y1: 168.768,
    x2: 283.98,
    y2: 240.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6BAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CAD5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1230_44605",
    x1: 373.241,
    y1: 136.144,
    x2: 350.743,
    y2: 148.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FA8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656831,
    stopColor: "#CDD3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1230_44605",
    x1: 324.601,
    y1: 150.708,
    x2: 304.819,
    y2: 199.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656831,
    stopColor: "#ADB4FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1230_44605",
    x1: 212.245,
    y1: 325.01,
    x2: 212.245,
    y2: 335.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE8D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1230_44605",
    x1: 212.769,
    y1: 301.587,
    x2: 212.769,
    y2: 328.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE0BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1230_44605",
    x1: 212.267,
    y1: 291.307,
    x2: 212.077,
    y2: 316.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#483029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F4326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1230_44605",
    x1: 206.191,
    y1: 388.408,
    x2: 215.305,
    y2: 329.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0403741,
    stopColor: "#6688FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F094FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1230_44605",
    x1: 211.284,
    y1: 345.996,
    x2: 211.284,
    y2: 375.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1230_44605",
    x1: 211.546,
    y1: 375.426,
    x2: 211.546,
    y2: 378.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1230_44605",
    x1: 179.847,
    y1: 315.698,
    x2: 177.305,
    y2: 331.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FA8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656831,
    stopColor: "#CDD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1230_44605",
    x1: 173.847,
    y1: 174.698,
    x2: 171.305,
    y2: 190.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FA8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656831,
    stopColor: "#CDD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1230_44605",
    x1: 386.681,
    y1: 83.9268,
    x2: 386.681,
    y2: 44.8665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4DBFF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F8FBFF",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EDF5FF",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E4F0FF",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DEECFF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#DAEAFF",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1230_44605",
    x1: 459.873,
    y1: 102.312,
    x2: 459.873,
    y2: 13.8671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FEFEFF",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FBFCFF",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F5F9FF",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#EEF5FF",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#E4EFFF",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1230_44605",
    x1: 78.0296,
    y1: 183.072,
    x2: 78.0296,
    y2: 137.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9E8FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.ddb3469b33b3dcd9c878b4e94c63782a.svg";
export { ForwardRef as ReactComponent };